import { isAncestorOfClass } from '../is-ancestor-of-class';

export function clickedInsideElementWithClass(
	event: MouseEvent,
	className: string
) {
	return isAncestorOfClass(event.target as Element, className, true);
}
